<template>
	<div id="check" class="col-lg-8">
		<form>
			<div class="tile">
				<div class="form-group">
					<div class="text required checkLabel">
						<label class="text required" for="uid">
							Укажите исходящий номер, полученный при отправке обращения:
						</label>
					</div>
					<div v-show="errors.find(x => x === 'uid')" class="formErrors">
						<strong>
							Отсутствует номер
						</strong>
					</div>
					<div class="input-field">
						<input v-model="uid" id="uid" class="text-input" type="text" required="">
					</div>
				</div>
				<button @click.prevent="check" class="btn blue" name="submit_answer" type="submit">Показать
					результат</button>
			</div>
		</form>

		<div class="tile">
			<div v-if="isCheck">
				Статус обращения: {{ status }}

				<div class="review__nav">
					<div class="review__nav-elems">
						<a class="review__nav-elem" :class="{ active: select === 'content' }"
							@click="() => setSelect('content')">
							Содержание
						</a>
						<a class="review__nav-elem" :class="{ active: select === 'consideration' }"
							@click="() => setSelect('consideration')">
							Рассмотрение
						</a>
					</div>
				</div>
				<div v-if="select === 'content'" class="review__content">
					<table>
						<tr v-for="field in fields" :key="field.id" class="review__content-elems review__content-elem">
							<td class="review__content-name" >{{ field.name }}</td>
							<td class="review__content-text">{{ data[field.id] }}</td>
						</tr>
					</table>
				</div>
				<div v-if="select === 'consideration'" class="review__content">
					<div class="col-xs-12 review__title">Этапы рассмотрения обращения</div>
					<div v-for="status in statuses" :key="status.date" class="col-xs-12 review__stage">
						<div class="review__stage-title">
							{{ status.name }}
							<div class="review__stage-date">
								{{ new Date(status.time).toLocaleString().substring(0, 17) }}
							</div>
						</div>
						<div class="review__stage-elem">
							{{ status.comment }}
						</div>
					</div>
				</div>
			</div>
			<div class="formErrors">{{ error }}</div>
		</div>
	</div>
</template>

<script>
import getStatus from '@/functions/getStatus'
import { getConfig } from '@/auth'

const getStatusName = (msed_id) => {
	if (msed_id === 1) return 'Обращение зарегистрировано'
	if (msed_id === 2) return 'Обращение направлено на рассмотрение'
	if (msed_id === 3) return 'Обращение направлено на исполнение'
	if (msed_id === 4) return 'Обращение рассмотрено'
	
	return ''
}

const getStatusComment = (status) => {
	const msed_id = status?.status_type?.msed_id 

	if (msed_id === 1) return `Регистрационный номер обращения в СЭД: ${status?.edo_number}`
	if (msed_id === 2) return ''
	if (msed_id === 3) return ''
	if (msed_id === 4) return 'Результат: подготовлен ответ.'
	
	return ''
}


export default {
	data() {
		return {
			errors: [],
			uid: new URL(location.href).searchParams.get('uid') ?? '',
			status: '',
			error: '',
			isCheck: false,
			select: 'content',
			urlPDF: getConfig().appealsUrl,
			fields: [
				{ id: 'date_ip', name: 'Дата обращение' },
				{ id: 'uid', name: 'Исходящий номер обращения' },
				{ id: 'registered_number', name: 'Номер в МСЭД' },
				{ id: 'registered_date_local', name: 'Дата регистрации в МСЭД' },
				{ id: 'fio', name: 'ФИО заявителя' },
				{ id: 'social_group_name', name: 'Социальное группа' },
				{ id: 'preferential_group_name', name: 'Льготный состав' },
				{ id: 'zone_name', name: 'Получатель' },
				{ id: 'theme', name: 'Тема обращения' },
				{ id: 'topic_view', name: 'Текст обращения' },
				{ id: 'email_view', name: 'EMail заявителя' },
				{ id: 'files', name: 'Количество приложений' },
				{ id: 'answer_number', name: 'Номер документа ответа' },
			],
			data: {},
			statuses: []
		}
	},
	mounted() {
		if (this.uid !== '') {
			this.check()
		}
	},
	methods: {
		check: function () {
			this.errors = []

			let required = [
				{ field: 'uid', value: '' },
			]

			required.forEach(x => {
				if (!this[x.field] || this[x.field] === x.value) {
					this.errors.push(x.field)
				}
			})

			if (this.errors.length === 0) {
				let uid = this.uid
				this.data = {}
				this.isCheck = false

				fetch(`${getConfig().appealsUrl}/${uid}`)
					.then(x => {
						if (x.status >= 400) {
							return { error: `Ошибка: Обращение с номером ${uid} не найдено` }
						}
						return x.json()
					})
					.then(x => {
						if (x.error) {
							this.error = x?.error ?? ''
						} else {
							this.data = x.data
							this.data.fio = `${x.data.last_name ?? ''} ${x.data.first_name ?? ''} ${x.data.middle_name ?? ''}`
							this.data.zone_name = x.data.zone.name
							this.data.registered_number = x.data.registered_number
							this.data.social_group_name = x.data.social_group.name
							this.data.preferential_group_name = x.data.preferential_group.name
							this.data.date_ip = new Date(x.data.date).toLocaleString()
							this.data.registered_date_local = x.data.registered_date ? new Date(x.data.registered_date).toLocaleDateString() : '';
							this.data.status_desc = getStatus(x.data?.status_type?.msed_id)
							this.status =  getStatus(x.data?.status_type?.msed_id)	
							this.data.files = x.data?.file_count > 0 ? `${x.data?.file_count}` : 'Приложений нет'

							this.data.topic_view = `По соображениям безопасности данный контент не показывается`
							this.data.email_view = `По соображениям безопасности данный контент не показывается`

							x.data.statuses.forEach(status => {
								status.name = getStatusName(status?.status_type?.msed_id)
								status.comment = getStatusComment(status)
							})

							this.statuses = x.data.statuses
							this.isCheck = true;
							this.error = '';
						}
					})
			}
		},
		setSelect: function (select) {
			this.select = select
		}
	}
}
</script>